/* import __COLOCATED_TEMPLATE__ from './text-overflow.hbs'; */
import Component, { setComponentTemplate } from "@ember/component";
import TEMPLATE from "./text-overflow.hbs";
export default setComponentTemplate(TEMPLATE, Component.extend({}));